import { render, staticRenderFns } from "./PrinterDetail.vue?vue&type=template&id=25549d52&scoped=true"
import script from "./PrinterDetail.vue?vue&type=script&lang=js"
export * from "./PrinterDetail.vue?vue&type=script&lang=js"
import style0 from "./PrinterDetail.vue?vue&type=style&index=0&id=25549d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25549d52",
  null
  
)

export default component.exports